import { createFileRoute } from '@tanstack/react-router'
import AdminAgencies from '@/features/admin/agencies'

export const Route = createFileRoute('/_admin/admin/agencies/')({
  component: AdminAgencies,
})
